import { Controller } from "@hotwired/stimulus"
import { Modal } from 'flowbite';

export default class extends Controller {
  static targets = [ 'modal', 'backdrop' ];

  connect() {
    try {
      this.revealHiddenAncestors();

      // Initialize Flowbite modal when component connects
      this.modal = new Modal(this.modalTarget, {
        backdrop: 'dynamic',
        backdropClasses: 'bg-gray-900/50 fixed inset-0 z-40',
        closable: true,
        onHide: () => {
          this.cleanupOverlay();
        }
      });
      
      // Show the modal immediately after initialization
      this.modal.show();
      
      // Add click listener to our backdrop for closing
      if (this.hasBackdropTarget) {
        this.backdropTarget.addEventListener('click', () => {
          this.hideModal();
        });
      }
    } catch (error) {
      console.error('Error initializing modal:', error);
    }
  }

  hideModal(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (this.modal) {
      this.modal.hide();
    }
    
    this.cleanupOverlay();
    
    // Hide the layout's modal container (the outer wrapper)
    const layoutModalContainer = document.getElementById(this.modalTarget.id);
    if (layoutModalContainer && layoutModalContainer !== this.modalTarget) {
      layoutModalContainer.classList.add('hidden');
    }
    
    // Also check parent elements for modal containers
    let parent = this.element.parentElement;
    while (parent) {
      if (parent.classList.contains('fixed') && parent.classList.contains('z-50')) {
        parent.classList.add('hidden');
      }
      parent = parent.parentElement;
    }
    
    // Clear the turbo frame to fully remove the modal
    const turboFrame = this.element.closest('turbo-frame');
    if (turboFrame) {
      turboFrame.innerHTML = '';
    }
  }

  cleanupOverlay() {
    // Remove any lingering Flowbite overlays
    const overlays = document.querySelectorAll('[modal-backdrop]');
    overlays.forEach((overlay) => overlay.remove());
    
    // Remove our custom backdrop
    if (this.hasBackdropTarget) {
      this.backdropTarget.remove();
    }
    
    // Find and hide/remove all modal-like overlays
    const allOverlays = document.querySelectorAll('.fixed.inset-0, .fixed[class*="z-"]');
    
    allOverlays.forEach((overlay) => {
      const classes = Array.from(overlay.classList);
      const hasBg = classes.some(c => c.includes('bg-gray'));
      
      if (hasBg || overlay.hasAttribute('modal-backdrop') || overlay.id.includes('backdrop')) {
        overlay.remove();
      }
    });
    
    // Remove body overflow hidden if set
    document.body.classList.remove('overflow-hidden');
  }

  disconnect() {
    // Clean up when controller disconnects
    if (this.modal) {
      this.modal.hide();
      this.cleanupOverlay();
    }
  }

  revealHiddenAncestors() {
    let element = this.element.parentElement;

    while (element) {
      element.classList.remove("hidden");
      element = element.parentElement;
    }
  }
}

